import { CONVERSATION_ENDPOINT } from './constants';
import { UpdateConversationParameters } from './types';

export const validateUpdateConversationParams = (
  parameters: UpdateConversationParameters,
) => {
  const conversationId = parameters?.conversationId;
  const custom = parameters?.custom;

  if (!conversationId) {
    return new Error('A conversationId must be provided.');
  }

  if (!custom) {
    return new Error(
      'Missing one or more of the required properties: customAttributes',
    );
  }

  return undefined;
};

export const makeConversationEndpoint = (id: string) => {
  return `/c/v2/conversations/${id}` as typeof CONVERSATION_ENDPOINT;
};
